

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GetAllChatRoomsWithReceiverInfo
// GETALLCHATROOMSWITHRECEIVERINFO
const GETALLCHATROOMSWITHRECEIVERINFO= createAsyncThunk(
  "GetAllChatRoomsWithReceiverInfo/GetAllChatRoomsWithReceiverInfo",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const GetAllChatRoomsWithReceiverInfoSlice = createSlice({
  name: "GetAllChatRoomsWithReceiverInfoSlice",
  initialState: {
    GetAllChatRoomsWithReceiverInfo: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfGetAllChatRoomsWithReceiverInfo: (state) => {
        state.GetAllChatRoomsWithReceiverInfo.loading = false
        state.GetAllChatRoomsWithReceiverInfo.error = false
        state.GetAllChatRoomsWithReceiverInfo.data = []
        state.GetAllChatRoomsWithReceiverInfo.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCHATROOMSWITHRECEIVERINFO.fulfilled, (state, action) => {
      state.GetAllChatRoomsWithReceiverInfo = {
        ...state.GetAllChatRoomsWithReceiverInfo,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCHATROOMSWITHRECEIVERINFO.pending, (state, action) => {
      state.GetAllChatRoomsWithReceiverInfo = {
        ...state.GetAllChatRoomsWithReceiverInfo,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCHATROOMSWITHRECEIVERINFO.rejected, (state, action) => {
      state.GetAllChatRoomsWithReceiverInfo = {
        ...state.GetAllChatRoomsWithReceiverInfo,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const GetAllChatRoomsWithReceiverInfoAction = {
    GETALLCHATROOMSWITHRECEIVERINFO,
};

export { GetAllChatRoomsWithReceiverInfoAction };
export default GetAllChatRoomsWithReceiverInfoSlice.reducer;
export const {setInitialStateOfGetAllChatRoomsWithReceiverInfo} = GetAllChatRoomsWithReceiverInfoSlice.actions